/*
  glossee-mega-debug.js — TEMPORARY instrumentation for the intermittent "mega opens half/empty" report.

  *** DEV THEME ONLY (Arda Web Design Dev, 189412704576). Never push this to the live theme. ***
  *** Delete this asset and its <script> tag in sections/header.liquid once the bug is understood. ***

  This file only OBSERVES. It adds passive listeners, reads the DOM and reads the public fields of the
  <glossee-mega-menu> instance. It never calls preventDefault, never changes a class, an attribute or a
  style that anything renders from, and never patches a method of the component. The single DOM write is
  document.documentElement.dataset.glosseeMegaBadState, which no stylesheet selects on, so the storefront
  looks and behaves exactly as it does without this file.

  What it is for: the panel's expected content is derived from the server-rendered DOM of each panel
  (how many rail categories, which sub-wrap belongs to each, how many promo tiles), so the detector
  compares the live panel against its own markup instead of against a hard-coded shape.

  Console entry points:
    window.__glosseeMegaDebug.report()   - short summary, returns the object
    window.__glosseeMegaDebug.dump()     - full JSON string (events + states + bad states) to copy
    window.__glosseeMegaDebug.lastBadState
    window.__glosseeMegaDebug.reset()
*/
(function () {
  'use strict';
  if (window.__glosseeMegaDebug) return;

  var MAX_EVENTS = 200;
  var MAX_STATES = 200;
  var MAX_BAD = 40;
  var SETTLE_MS = 700; // longer than the open stagger (100 + 60i + 250 = 470) and the 180ms panel fade

  var D = (window.__glosseeMegaDebug = {
    version: 1,
    enabled: true,
    seq: 0, // our own monotonic open/close token; the component has none of its own
    events: [],
    states: [],
    badStates: [],
    lastBadState: null,
    badCount: 0,
    openCount: 0,
    structure: null,
    lastPointer: { enter: null, leave: null, relatedEnter: null, relatedLeave: null },
    lastFocus: { focusin: null, focusout: null, relatedFocusin: null },
    lastEnvironment: { visibility: document.visibilityState, width: window.innerWidth, scrollY: 0 }
  });

  function ring(arr, item, max) {
    arr.push(item);
    if (arr.length > max) arr.splice(0, arr.length - max);
    return item;
  }

  function describe(el) {
    if (!el) return null;
    if (el === window) return 'window';
    if (el === document) return 'document';
    if (el.nodeType !== 1) return String(el.nodeName || el);
    var id = el.id ? '#' + el.id : '';
    var cls = typeof el.className === 'string' && el.className ? '.' + el.className.trim().split(/\s+/).slice(0, 3).join('.') : '';
    var hook = '';
    ['data-glossee-mega-trigger', 'data-glossee-mega-panel', 'data-glossee-cat', 'data-glossee-sub', 'data-glossee-cats'].forEach(function (a) {
      if (el.hasAttribute && el.hasAttribute(a)) hook += '[' + a + '=' + el.getAttribute(a) + ']';
    });
    var txt = (el.textContent || '').trim().replace(/\s+/g, ' ').slice(0, 24);
    return el.tagName.toLowerCase() + id + cls + hook + (txt ? ' "' + txt + '"' : '');
  }

  function menuEl() { return document.querySelector('glossee-mega-menu'); }

  /* ---------- structure, read once from the server-rendered DOM (nothing hard-coded) ---------- */
  function readStructure() {
    var out = {};
    Array.prototype.forEach.call(document.querySelectorAll('[data-glossee-mega-panel]'), function (panel) {
      var id = panel.getAttribute('data-glossee-mega-panel');
      var cats = Array.prototype.map.call(panel.querySelectorAll('[data-glossee-cat]'), function (c) {
        return c.getAttribute('data-glossee-cat');
      });
      var subs = Array.prototype.map.call(panel.querySelectorAll('[data-glossee-sub]'), function (s) {
        return s.getAttribute('data-glossee-sub');
      });
      var neu = panel.querySelector('.glossee-mega__neu');
      out[id] = {
        label: panel.getAttribute('aria-label'),
        scope: panel.getAttribute('data-glossee-panel-scope'),
        layout: /--cats/.test(panel.className) ? 'cats' : 'cols',
        railCount: cats.length,
        catIds: cats,
        subCount: subs.length,
        subIds: subs,
        // a rail item is expected to have exactly one sub-wrap carrying the same id
        pairs: cats.map(function (c) { return { cat: c, hasSub: subs.indexOf(c) !== -1 }; }),
        declaresPromos: panel.hasAttribute('data-glossee-has-promos'),
        promoCount: neu ? neu.querySelectorAll('.glossee-mega__tile').length : 0,
        hasNeu: !!neu
      };
    });
    return out;
  }

  function box(el) {
    if (!el) return null;
    var r = el.getBoundingClientRect();
    var cs = getComputedStyle(el);
    return {
      w: Math.round(r.width), h: Math.round(r.height), x: Math.round(r.x), y: Math.round(r.y),
      display: cs.display, visibility: cs.visibility, opacity: +(+cs.opacity).toFixed(3),
      transform: cs.transform === 'none' ? 'none' : cs.transform,
      pointerEvents: cs.pointerEvents,
      hidden: !!el.hidden, inert: !!el.inert
    };
  }

  function anims(root) {
    if (!root || typeof root.getAnimations !== 'function') return [];
    var list = [];
    Array.prototype.forEach.call(root.querySelectorAll('.glossee-mega__col'), function (col, i) {
      (col.getAnimations() || []).forEach(function (a) {
        list.push({
          col: i,
          id: a.id || '(none)',
          playState: a.playState,
          currentTime: a.currentTime == null ? null : Math.round(a.currentTime),
          // a stale animation is one still "running" for a panel that is no longer the open one
          fill: a.effect && a.effect.getTiming ? a.effect.getTiming().fill : null
        });
      });
    });
    return list;
  }

  function activePanel() {
    var panels = document.querySelectorAll('[data-glossee-mega-panel]');
    for (var i = 0; i < panels.length; i++) {
      if (!panels[i].hidden && panels[i].classList.contains('is-active')) return panels[i];
    }
    return null;
  }

  function snapshot(reason) {
    var m = menuEl();
    if (!m) return null;
    var panel = activePanel();
    var shellOpen = m.classList.contains('is-open');
    var s = {
      t: Math.round(performance.now()),
      iso: new Date().toISOString(),
      reason: reason,
      seq: D.seq,
      // menu-level
      shellOpen: shellOpen,
      mode: m.mode === undefined ? '(n/a)' : m.mode,
      openId: m.openId === undefined ? '(n/a)' : m.openId,
      shell: box(m),
      bodyFlag: document.body.classList.contains('glossee-mega-open'),
      // pending timers (read straight off the component instance; null = no timer pending)
      timers: {
        openTimer: m.openTimer != null,
        closeTimer: m.closeTimer != null,
        rowTimer: m.rowTimer != null,
        cleanupTimer: m.cleanupTimer != null,
        videoSyncTimer: m.videoSyncTimer != null
      },
      // panel-level
      panelId: panel ? panel.getAttribute('data-glossee-mega-panel') : null,
      panelLabel: panel ? panel.getAttribute('aria-label') : null,
      panelClasses: panel ? panel.className : null,
      panelAriaHidden: panel ? panel.getAttribute('aria-hidden') : null,
      panelBox: box(panel),
      panelHideTimerPending: panel ? panel.glosseeHideTimer != null : null,
      // every panel's hidden/active flags, to catch "two panels half-open"
      panels: Array.prototype.map.call(document.querySelectorAll('[data-glossee-mega-panel]'), function (p) {
        return {
          id: p.getAttribute('data-glossee-mega-panel'),
          hidden: !!p.hidden,
          active: p.classList.contains('is-active'),
          opacity: +(+getComputedStyle(p).opacity).toFixed(2),
          hideTimer: p.glosseeHideTimer != null
        };
      }),
      triggers: Array.prototype.map.call(document.querySelectorAll('[data-glossee-mega-trigger]'), function (t) {
        return { id: t.getAttribute('data-glossee-mega-trigger'), ariaExpanded: t.getAttribute('aria-expanded') };
      }),
      // pointer / focus context
      lastPointer: JSON.parse(JSON.stringify(D.lastPointer)),
      lastFocus: JSON.parse(JSON.stringify(D.lastFocus)),
      focusTarget: describe(document.activeElement),
      environment: {
        visibility: document.visibilityState,
        width: window.innerWidth,
        height: window.innerHeight,
        scrollY: Math.round(window.pageYOffset),
        reducedMotion: window.matchMedia('(prefers-reduced-motion: reduce)').matches
      }
    };

    if (panel) {
      var cats = panel.querySelectorAll('[data-glossee-cat]');
      var subs = panel.querySelectorAll('[data-glossee-sub]');
      var activeCats = [];
      var activeIdx = -1;
      Array.prototype.forEach.call(cats, function (c, i) {
        if (c.classList.contains('is-active')) { activeCats.push(c.getAttribute('data-glossee-cat')); activeIdx = i; }
      });
      var visibleSubs = [];
      Array.prototype.forEach.call(subs, function (sub) {
        if (!sub.hidden) visibleSubs.push(sub.getAttribute('data-glossee-sub'));
      });
      var activeSubEl = panel.querySelector('[data-glossee-sub]:not([hidden])');
      var neu = panel.querySelector('.glossee-mega__neu');
      var tiles = neu ? neu.querySelectorAll('.glossee-mega__tile') : [];

      s.rail = {
        count: cats.length,
        activeIndex: activeIdx,
        activeId: activeCats.length === 1 ? activeCats[0] : null,
        activeCount: activeCats.length,
        activeIds: activeCats,
        ariaExpanded: Array.prototype.map.call(cats, function (c) { return c.getAttribute('aria-expanded'); }),
        box: box(panel.querySelector('.glossee-mega__cats'))
      };
      s.middle = {
        subCount: subs.length,
        visibleCount: visibleSubs.length,
        visibleIds: visibleSubs,
        activeSubId: activeSubEl ? activeSubEl.getAttribute('data-glossee-sub') : null,
        activeSubBox: box(activeSubEl),
        midBox: box(panel.querySelector('.glossee-mega__mid')),
        linkCount: activeSubEl ? activeSubEl.querySelectorAll('a').length : 0
      };
      s.promos = {
        declared: panel.hasAttribute('data-glossee-has-promos'),
        tileCount: tiles.length,
        neuBox: box(neu),
        visibleTiles: Array.prototype.filter.call(tiles, function (t) { return t.getBoundingClientRect().height > 0; }).length,
        firstTileBox: tiles.length ? box(tiles[0]) : null
      };
      s.animations = anims(panel);
    }
    return s;
  }

  /* ---------- bad-state detector, measured against this panel's own server-rendered structure ---------- */
  function evaluate(s) {
    if (!s || !s.panelId) return null;
    var expect = D.structure && D.structure[s.panelId];
    if (!expect) return null;
    // only judge a panel that is genuinely presented to the user and has settled
    if (!s.shellOpen) return null;
    if (!s.panelBox || s.panelBox.hidden) return null;
    if (s.panelBox.opacity < 0.9) return null;
    if (s.panelBox.display === 'none' || s.panelBox.visibility === 'hidden') return null;
    // The open/switch stagger legitimately holds the columns at opacity 0 during its delay
    // (fill: 'backwards'), so a frame taken while it is still playing is not evidence of anything.
    // An animation still "running" well past its longest leg (100 + 60*2 + 250 = 470ms) is NOT
    // normal, so that case is deliberately left judgeable.
    if (s.animations && s.animations.some(function (a) {
      return a.id === 'glossee-stagger' && a.playState === 'running' && a.currentTime != null && a.currentTime < 600;
    })) return null;

    var faults = [];
    if (expect.layout === 'cats') {
      if (expect.railCount > 0) {
        if (s.rail.activeCount !== 1) faults.push('rail: expected exactly 1 active category, found ' + s.rail.activeCount);
        if (!s.rail.box || s.rail.box.h === 0) faults.push('rail: rendered height is 0');
      }
      if (expect.subCount > 0) {
        if (s.middle.visibleCount !== 1) faults.push('middle: expected exactly 1 visible sub-wrap, found ' + s.middle.visibleCount);
        if (!s.middle.activeSubBox || s.middle.activeSubBox.h === 0) faults.push('middle: visible sub-wrap has 0 height');
        if (s.middle.activeSubBox && s.middle.activeSubBox.opacity < 0.05) faults.push('middle: visible sub-wrap opacity ' + s.middle.activeSubBox.opacity);
        if (s.middle.midBox && s.middle.midBox.h === 0) faults.push('middle: column has 0 height');
        if (s.rail.activeId && s.middle.activeSubId && s.rail.activeId !== s.middle.activeSubId) {
          faults.push('mismatch: active rail "' + s.rail.activeId + '" but visible sub "' + s.middle.activeSubId + '"');
        }
      }
      if (expect.declaresPromos && expect.promoCount > 0) {
        if (!s.promos.neuBox || s.promos.neuBox.h === 0) faults.push('promos: cards column has 0 height');
        if (s.promos.neuBox && s.promos.neuBox.opacity < 0.05) faults.push('promos: cards column opacity ' + s.promos.neuBox.opacity);
        if (s.promos.visibleTiles === 0) faults.push('promos: 0 of ' + expect.promoCount + ' tiles rendered');
      }
    }
    // more than one panel presented at once
    var shown = s.panels.filter(function (p) { return !p.hidden && p.active; });
    if (shown.length > 1) faults.push('two panels active at once: ' + shown.map(function (p) { return p.id; }).join(', '));

    return faults.length ? faults : null;
  }

  function check(reason) {
    if (!D.enabled) return;
    var s = snapshot(reason);
    if (!s) return;
    ring(D.states, s, MAX_STATES);
    var faults = evaluate(s);
    if (faults) {
      s.faults = faults;
      s.recentEvents = D.events.slice(-30);
      D.badCount++;
      D.lastBadState = s;
      ring(D.badStates, s, MAX_BAD);
      try { document.documentElement.dataset.glosseeMegaBadState = 'true'; } catch (e) {}
      console.warn('[GLOSSEE MEGA BAD STATE]', s);
    }
    return s;
  }

  /* settle timer: re-check once the open animation and the fade can no longer be the reason */
  var settleTimer = null;
  function scheduleSettleCheck(reason) {
    if (settleTimer) clearTimeout(settleTimer);
    settleTimer = setTimeout(function () {
      settleTimer = null;
      check(reason + ':settled');
    }, SETTLE_MS);
  }

  function logEvent(type, target, related, extra) {
    var e = {
      t: Math.round(performance.now()),
      type: type,
      target: describe(target),
      relatedTarget: describe(related),
      seq: D.seq
    };
    if (extra) for (var k in extra) e[k] = extra[k];
    return ring(D.events, e, MAX_EVENTS);
  }

  /* ---------- wiring ---------- */
  function start() {
    var m = menuEl();
    if (!m) return;
    D.structure = readStructure();

    var zones = [];
    function zone(el, name) { if (el) zones.push({ el: el, name: name }); }

    Array.prototype.forEach.call(document.querySelectorAll('[data-glossee-mega-trigger]'), function (t) {
      zone(t, 'nav:' + t.getAttribute('data-glossee-mega-trigger'));
    });
    zone(m, 'shell');
    Array.prototype.forEach.call(document.querySelectorAll('[data-glossee-mega-panel]'), function (p) {
      var id = p.getAttribute('data-glossee-mega-panel');
      zone(p.querySelector('.glossee-mega__cats'), 'rail:' + id);
      zone(p.querySelector('.glossee-mega__mid'), 'middle:' + id);
      zone(p.querySelector('.glossee-mega__neu'), 'promos:' + id);
    });
    Array.prototype.forEach.call(document.querySelectorAll('[data-glossee-cat]'), function (c) {
      zone(c, 'railitem:' + c.getAttribute('data-glossee-cat'));
    });

    zones.forEach(function (z) {
      ['pointerenter', 'pointerleave', 'mouseenter', 'mouseleave', 'focusin', 'focusout'].forEach(function (type) {
        z.el.addEventListener(type, function (ev) {
          var rel = ev.relatedTarget || null;
          if (type === 'pointerenter' || type === 'mouseenter') {
            D.lastPointer.enter = z.name + ' | ' + describe(ev.target);
            D.lastPointer.relatedEnter = describe(rel);
          } else if (type === 'pointerleave' || type === 'mouseleave') {
            D.lastPointer.leave = z.name + ' | ' + describe(ev.target);
            D.lastPointer.relatedLeave = describe(rel);
          } else if (type === 'focusin') {
            D.lastFocus.focusin = z.name + ' | ' + describe(ev.target);
            D.lastFocus.relatedFocusin = describe(rel);
          } else {
            D.lastFocus.focusout = z.name + ' | ' + describe(ev.target);
          }
          logEvent(type, ev.target, rel, { zone: z.name });
        }, { passive: true, capture: false });
      });
    });

    // every state transition of the shell or a panel
    var mo = new MutationObserver(function (records) {
      var interesting = false;
      for (var i = 0; i < records.length; i++) {
        var r = records[i];
        if (r.type !== 'attributes') continue;
        var a = r.attributeName;
        if (a === 'class' || a === 'hidden' || a === 'aria-expanded' || a === 'aria-hidden' || a === 'style') {
          interesting = true;
          logEvent('mutate:' + a, r.target, null, { value: a === 'class' ? r.target.className : r.target.getAttribute(a) });
        }
      }
      if (!interesting) return;
      var openNow = m.classList.contains('is-open');
      if (openNow !== D._wasOpen) {
        D._wasOpen = openNow;
        D.seq++;
        if (openNow) D.openCount++;
        logEvent(openNow ? 'SHELL_OPEN' : 'SHELL_CLOSE', m, null, { seq: D.seq });
      }
      check('mutation');
      if (openNow) scheduleSettleCheck('open');
    });
    mo.observe(m, { attributes: true, subtree: true, attributeFilter: ['class', 'hidden', 'aria-expanded', 'aria-hidden', 'style'] });
    Array.prototype.forEach.call(document.querySelectorAll('[data-glossee-mega-trigger]'), function (t) {
      mo.observe(t, { attributes: true, attributeFilter: ['aria-expanded'] });
    });

    // environment events the report asks about
    document.addEventListener('visibilitychange', function () {
      D.lastEnvironment.visibility = document.visibilityState;
      logEvent('visibilitychange', document, null, { state: document.visibilityState });
      check('visibilitychange');
      scheduleSettleCheck('visibilitychange');
    }, { passive: true });
    window.addEventListener('resize', function () {
      D.lastEnvironment.width = window.innerWidth;
      logEvent('resize', window, null, { w: window.innerWidth, h: window.innerHeight });
      scheduleSettleCheck('resize');
    }, { passive: true });
    var lastScrollLog = 0;
    window.addEventListener('scroll', function () {
      var now = performance.now();
      if (now - lastScrollLog > 250) {
        lastScrollLog = now;
        logEvent('scroll', window, null, { y: Math.round(window.pageYOffset) });
      }
      if (m.classList.contains('is-open')) scheduleSettleCheck('scroll');
    }, { passive: true });
    window.addEventListener('pageshow', function (ev) {
      logEvent('pageshow', window, null, { persisted: ev.persisted });
    }, { passive: true });

    D._wasOpen = m.classList.contains('is-open');
    check('init');
    console.info('[glossee mega debug] armed. structure:', D.structure, '— run window.__glosseeMegaDebug.report()');
  }

  D.report = function () {
    var r = {
      badCount: D.badCount,
      openCount: D.openCount,
      events: D.events.length,
      states: D.states.length,
      lastBadState: D.lastBadState,
      structure: D.structure
    };
    console.log('[glossee mega debug] bad states: ' + D.badCount + ' over ' + D.openCount + ' opens');
    if (D.lastBadState) console.warn('last bad state:', D.lastBadState);
    return r;
  };
  D.dump = function () {
    return JSON.stringify({
      version: D.version, badCount: D.badCount, openCount: D.openCount,
      structure: D.structure, badStates: D.badStates,
      states: D.states.slice(-60), events: D.events,
      ua: navigator.userAgent, url: location.href,
      theme: window.Shopify && window.Shopify.theme ? window.Shopify.theme.id : null
    });
  };
  D.reset = function () {
    D.events.length = 0; D.states.length = 0; D.badStates.length = 0;
    D.lastBadState = null; D.badCount = 0; D.openCount = 0;
    try { delete document.documentElement.dataset.glosseeMegaBadState; } catch (e) {}
    return 'reset';
  };
  D.check = function () { return check('manual'); };
  D.snapshot = function () { return snapshot('manual'); };

  if (window.customElements && customElements.whenDefined) {
    customElements.whenDefined('glossee-mega-menu').then(function () {
      if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
      else start();
    });
  } else if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
})();
